import React from "react";
import CanvasComponent from "./canvas-component";
import { Button, makeStyles } from "@material-ui/core";
import MoreFeature from "./Stepper";
import { maxContentHeight, maxDisplayHeight, primaryColorLight, useNeedResize } from "../lib/constants";
import Step3Container from "./stepContainers/Step3Container";
import Step1Container from "./stepContainers/Step1Container";
import Step2Container from "./stepContainers/Step2Container";

const useMenuCardStyles = makeStyles(
  {
    buttonStyling: {
      filter: "drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.25))",
      backgroundColor: "#e55b5e",
      color: "white",
      borderRadius: "7px",
      fontSize: "1.25em",
      height: "35px",
      "&:hover": {
        backgroundColor: primaryColorLight
      }
    },

    canvasContainer: {
      display: "flex",
      flexWrap: "wrap",
      overflow: "auto",
      width: "100%",
      flexGrow: "1",
      height: "100%",
      maxHeight: maxContentHeight
    },

    content: {
      flexShrink: 0,
      height: "100%",
      width: "100%",
      maxHeight: maxContentHeight,
      background: "#efefef",
      position: "relative",
      zIndex: 2,
      marginTop: 0,
      display: "flex",
      overflow: "hidden",
      alignItems: "center",
      "& h1": {
        color: " #4834d4",
        fontFamily: "Roboto",
        margin: "auto"
      }
    },

    contentContainer: {
      display: "flex",
      height: "92%",
      width: "100%",
      borderRadius: "12px",
      boxShadow: "rgb(213, 213, 213) 15px 15px 28px, rgb(255, 255, 255) -15px -15px 28px",
      margin: 0,
      position: "relative",
      maxWidth: "1200px",
      maxHeight: maxContentHeight,
      marginLeft: "10px",
      overflow: "hidden",
      marginTop: "7px"
    },

    displayCase: {
      display: "flex",
      flexDirection: "row",
      width: "95vw",
      maxWidth: "1215px",
      height: "95vh",
      maxHeight: maxDisplayHeight,
      background: "transparent"
    }
  },
  { name: "MenuCardStyles" }
);

function MenuCard(props) {
  const { focus, onClickCard, content } = props;
  const classes = useMenuCardStyles();

  const [needResize, containerRef] = useNeedResize();

  return (
    <div className={classes.displayCase}>
      {/* stepper bar in steps but not intro screen*/}
      {focus > 0 && <MoreFeature key={`wonderful-stepper-container-thing`} />}

      <div className={classes.contentContainer} ref={containerRef}>
        <div className={classes.content}>
          {focus === 1 && <Step1Container content={content} onClickCard={onClickCard} needResize={needResize} />}

          {focus === 2 && <Step2Container content={content} onClickCard={onClickCard} needResize={needResize} />}
          {/* step 3 split into tagcloud and taxonomy, each requires own component */}
          {focus === 3 && (
            // container for call to action button
            <Step3Container content={content} needResize={needResize} />
          )}

          {/* 3d model view step 4 */}
          {focus === 4 && (
            <div className={classes.canvasContainer}>
              <CanvasComponent />
            </div>
          )}

          {/* goodbye screen step 5 */}
          {focus === 5 && (
            <React.Fragment>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  width: "100%"
                }}
              >
                <p
                  style={{
                    fontSize: "1.7em",
                    fontWeight: "500",
                    color: "#424242",
                    marginBottom: "22px"
                  }}
                >
                  Interesse geweckt?
                </p>

                {/* contact button on final screen */}
                <Button
                  variant="contained"
                  target="_blank"
                  href="https://digital-business.nea-x.de/contact"
                  classes={{ root: classes.buttonStyling }}
                >
                  Kontakt aufnehmen
                </Button>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
}
export default MenuCard;
